import React, { Component, PropTypes } from 'react';
import { Form } from 'redux-form';
import idx from 'idx';
import partial from 'lodash/partial';
import classnames from 'classnames';
import DropdownMenu from 'common/components/dropdown_menu';
import { Field } from 'redux-form';
import {
  TextInputField, TextAreaField, SelectField, CheckBoxField, MoneyInputField, NumberInputField,
  FileSelectorField, TaggingField
} from 'common/components/form_fields';
import FeaturesField from 'admin/containers/features_field';
import EditSpecializationsField from 'profile/components/edit_specializations';

const COMPONENT_MAP = {
  input: TextInputField,
  textarea: TextAreaField,
  select: SelectField,
  checkbox: CheckBoxField,
  money: MoneyInputField,
  number: NumberInputField,
  features: FeaturesField,
  file: FileSelectorField,
  specializations: EditSpecializationsField,
  tagging: TaggingField
};

const getComponent = (type = 'input') => (COMPONENT_MAP[type]);

export default class DropdownWithModal extends Component {
  constructor(props) {
    super(props);

    this.state = { show: false, form: '' };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
  }

  onSubmitClick(e) {
    e.preventDefault();
    this.props.submit();
  }

  handleSubmit(values) {
    const { submitAction, forms, skipConfirmation } = this.props;
    const form = forms.find(({ formName }) => (formName === this.state.form));
    /* format form values so that file fields are properly represented */
    const data = Object.keys(values).reduce((acc, fieldName) => {
      return {
        ...acc,
        [fieldName]: idx(values[fieldName], _ => _.file)? values[fieldName].file : values[fieldName]
      };
    }, {});

    if (
      form && (
        skipConfirmation || window.confirm(form.confirmation || 'Are you sure you want to save?')
      )
    ) {
      submitAction(this.state.form, data, form.method).then(this.onToggle);
    }
  }

  onToggle(form) {
    this.props.reset();
    this.setState({ show: !this.state.show, form });
  }

  renderForm() {
    const { forms, handleSubmit, anyTouched } = this.props;
    const form = forms.find(({ formName }) => (formName === this.state.form));
    if (!form) {
      return null;
    }

    return (<Form key={this.state.form} onSubmit={handleSubmit(this.handleSubmit)}>
      <h2>{form.label}</h2>

      { form.pre && <div className="pre">{ form.pre }</div> }

      {form.fields.map(({
        label, name, type, placeholder, options, validate, rows, acceptedFileType
      }) => {
        const component = getComponent(type);
        return (<Field
          key={`${this.state.form}${name}`}
          component={component}
          name={name}
          label={label}
          placeholder={placeholder}
          validate={validate}
          options={options}
          allowEmpty={true}
          rows={rows}
          acceptedFileType={acceptedFileType}
          formTouched={anyTouched}
          useInputValue={true}
          resetValue=""
        />);
      })}
      <div className="modal-actions">
        <button className="btn btn-primary" onClick={this.onSubmitClick}>
          { form.actionLabel || "Save" }
        </button>
        <button className="btn btn-text" type="button" onClick={this.onToggle}>
          Cancel
        </button>
      </div>
    </Form>);
  }

  render() {
    const { forms, className, onToggle } = this.props;
    const { show, form } = this.state;
    const currentForm = forms.find(({ formName }) => (formName === form));

    const buttons = forms.map(({ label, show, formName }) => ({
      label, show, action: partial(this.onToggle, formName)
    }));

    return (<div className={className}>
      <DropdownMenu buttons={buttons} className="tile-menu" onToggle={onToggle} />
      {show && <div className="modal-dialog">
        <div className="modal-background" onClick={this.onToggle} />
        <div className={classnames("modal-content-container", {
          wide: idx(currentForm, _ => _.wide)
        })}>
          <div className="modal-content">
            {this.renderForm()}
          </div>
        </div>
      </div>}
    </div>);
  }
}

DropdownWithModal.propTypes = {
  forms: PropTypes.array.isRequired,
  submitAction: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onToggle: PropTypes.func,
  className: PropTypes.any,
  skipConfirmation: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./common/components/modal_dropdown_form.jsx